



































import Vue from "vue";

export default Vue.extend({
  name: "Previews",
  props: {
    items: { type: Array, default: () => [] },
    trigger: { type: Function, default: () => null },
    show: { type: Number, default: 3 },
  },
  computed: {
    leftover(): number {
      return this.items.length - this.show;
    },
  },
  methods: {
    scrollTo(hash: string): void {
      const el: HTMLElement | null = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  },
});
